























import { Prop } from 'vue-property-decorator';
import Component, { mixins } from 'vue-class-component';

import Formatter from '@/mixins/formatter';
import UrlMixin from '@/mixins/url';

@Component
export default class FixedBarForSmartDevice extends mixins(
  UrlMixin,
  Formatter
) {
  @Prop() initialTotalAmount!: number;
  @Prop() totalAmountOfMonth!: number;
}
